<script setup>
import { Dropdown } from 'uiv';
import { Bars3Icon } from '@heroicons/vue/24/solid';
import LinkText from '@/components/links/LinkText.vue';

defineProps({
  tag: {
    type: String,
    default: 'li',
  },

  appendToBody: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <Dropdown
    :tag="tag"
    :append-to-body="appendToBody"
    menu-right>
    <LinkText
      as="button"
      data-role="trigger"
      type="button"
      class="text-gray-300 hover:text-brand-blue">
      <slot name="trigger">
        <Bars3Icon class="h-6 w-6" />
        <span class="sr-only">Menu</span>
      </slot>
    </LinkText>

    <template #dropdown>
      <slot></slot>
    </template>
  </Dropdown>
</template>
